<div class="hpanel search-page-navbar-stickyyy gs-card">
  <div class="panel-body border-radius-top-left-right-6 gs-card-body">
    <div class="mainNav">
      <div class="navIteam">
        <div class="col-sm-2 entity-summary">
          <div><ng-icon name="tablerBriefcase"></ng-icon></div>
          <div class="entity-name">
            <h5> Jobs </h5>
          </div>
          <div *ngIf="totalJobsCount != null && totalJobsCount!= undefined && totalJobsCount != ''" class="entitycount">
            <span>{{totalJobsCount}}</span>
          </div>
        </div>
      </div>
      <div class="navIteam">
        <div class="input-group f-l input-sm">
          <input class="form-control" (keyup)="jobDataSearch($event)" [formControl]="clearInput" type="text" />
          <span class="input-group-addon"><ng-icon name="tablerSearch"></ng-icon></span>
          <span class="input-group-addon" (click)="clearData()"><ng-icon name="tablerX"></ng-icon></span>
        </div>
      </div>
      <div class="navIteam connectionbtn">
        <div class="btn-group" dropdown>
          <button id="button-animated" dropdownToggle type="button" class="btn dropdown-toggle fbtn"
            aria-controls="dropdown-animated">
            Filter<span class="mr-5"><img src="assets/icon/icons8-mail-filter-96.png" alt="" srcset=""
                class="filimg" /></span>
          </button>
          <!-- <ul id="dropdown-animated" *dropdownMenu class="dropdown-menu"
              role="menu" aria-labelledby="button-animated">
              <li role="menuitem"><a class="dropdown-item" (click)="apicall('CONNECTED')">All Connection</a></li>
            <li role="menuitem"><a class="dropdown-item" (click)="apicall('Invitation_Received')">Request Received</a></li>
            <li role="menuitem"><a class="dropdown-item" (click)="apicall('Invitation_Sent')">Invitations Sent </a></li>
          </ul> -->
        </div>
      </div>
      <div class="navIteam">
        <!-- <button class="btn btn-default displayflex dropdown-toggle">
          <span class="mr-5">
            <img src="assets/icon/icons8-mail-filter-96.png" alt="" srcset="" class="filimg" />
          </span>
          Filter
        </button> -->
        <button class="btn primary-btn">Advance Search</button>
      </div>
    </div>
  </div>
</div>

<div>
  <!--*ngIf="userData"-->
  <div class="search-content-layout">
    <div class="search-content-feed">
      <div class="col-md-12 padding-left-0 padding-right-8" *ngFor="let item of alljob">
        <app-job-card [viewSize]="'large'" [JobData]="item"></app-job-card>
      </div>
    </div>
    <div class="search-content-widget search-page-mr-tp-10">
      <app-common-widget [page]="'NETWORK_PAGE'" [inputData]="'NETWORK'"></app-common-widget>
    </div>
  </div>
</div>